import {Component} from '@angular/core';

@Component({
  selector: 'app-instance-discovered-emoji',
  standalone: true,
  imports: [],
  templateUrl: './instance-discovered-emoji.component.html',
  styleUrl: './instance-discovered-emoji.component.css',
})
export class InstanceDiscoveredEmojiComponent {}
